import { Button } from '@mui/material';

import { Loader } from '@/components/shared/loader';

// can remove this component once we move to MUI v6, as there a built in loading prop for the Button component.
export function LoaderButton() {
  return (
    <Button className='cursor-default pointer-events-none' variant='outlined'>
      <Loader size='medium' />
    </Button>
  );
}
